// Third party packages
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var CommunicationsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function CommunicationsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.createdCommunication$ = new BehaviorSubject(false);
    }
    /**
     * Create a new communication
     *
     * @since 1.0.0
     *
     * @param communication Communication data
     * @returns Observable<any>
     */
    CommunicationsService.prototype.create = function (communication) {
        if (communication.companyData) {
            if (communication.companyData.documents) {
                delete communication.companyData.documents;
            }
            if (communication.companyData.phonebook) {
                delete communication.companyData.phonebook;
            }
            if (communication.companyData.subProperties) {
                delete communication.companyData.subProperties;
            }
            if (communication.companyData.subUsers) {
                delete communication.companyData.subUsers;
            }
        }
        return this.apiService.apiCall('POST', 'communications', communication);
    };
    /**
     * Create a new communication
     *
     * @since 1.0.0
     *
     * @param communication Communication data
     * @returns Observable<any>
     */
    CommunicationsService.prototype.createSuppliers = function (communication) {
        return this.apiService.apiCall('POST', 'communications/suppliers', communication);
    };
    /**
     * Get communications list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    CommunicationsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'communications', params);
    };
    /**
     * Get an exportation file of all communications
     *
     * @since 1.0.0
     */
    CommunicationsService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'communications/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given communicationId data from back-end
     *
     * @since 1.0.0
     *
     * @param communicationId ID of the communication to get
     */
    CommunicationsService.prototype.get = function (communicationId) {
        var _this = this;
        return this.apiService.apiCall('GET', "communications/" + communicationId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Delete permanently a communication
     *
     * @since 1.0.0
     *
     * @param communicationId ID of the communication
     */
    CommunicationsService.prototype.delete = function (communicationId) {
        return this.apiService.apiCall('DELETE', "communications/" + communicationId);
    };
    /**
     * Emit a new value (always true) in the "createdCommunication$" behaviourSubject
     * This is used to let communication list knows when a communication has been
     * created from outside
     *
     * @since 1.0.0
     */
    CommunicationsService.prototype.onCommunicationCreated = function () {
        this.createdCommunication$.next(true);
    };
    CommunicationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommunicationsService_Factory() { return new CommunicationsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: CommunicationsService, providedIn: "root" });
    return CommunicationsService;
}());
export { CommunicationsService };
